import {PureComponent} from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'

const calendlyJS = 'calendly-js'
const calendlyCSS = 'calendly-css'

class CalendlyButton extends PureComponent {
  static defaultProps = {
    className: 'btn btn-primary',
  }

  static propTypes = {
    className: PropTypes.string,
    meetingUrl: PropTypes.string.isRequired,
  }

  componentDidMount() {
    this.setupCalendly()
  }

  componentWillUnmount() {
    this.removeCalendly()
  }

  setupCalendly = () => {
    const head = document.getElementsByTagName('head')[0]

    if (document.getElementById(calendlyJS) === null) {
      const script = document.createElement("script")
      script.src = 'https://assets.calendly.com/assets/external/widget.js'
      script.id = calendlyJS
      script.async = true

      head.appendChild(script)
    }

    if (document.getElementById(calendlyCSS) === null) {
      const link = document.createElement('link')
      link.href = 'https://assets.calendly.com/assets/external/widget.css'
      link.id = calendlyCSS
      link.rel = 'stylesheet'

      head.appendChild(link)
    }
  }

  removeCalendly = () => {
    const head = document.getElementsByTagName('head')[0]

    head.removeChild(document.getElementById(calendlyJS))
    head.removeChild(document.getElementById(calendlyCSS))
  }

  openCalendlyWidget = () => {
    this.setupCalendly()

    window.Calendly.initPopupWidget({
      url: this.props.meetingUrl,
      prefill: {
        name: this.props?.currentUser?.fullname ?? '',
        email: this.props?.currentUser?.email ?? '',
        customAnswers: {
          a1: this.props?.currentUser?.tel ?? ''
        }
      }
    })
  }

  render() {
    return <button onClick={this.openCalendlyWidget} className={this.props.className}>
      {this.props.children}
    </button>
  }
}

export default connect(
  (state) => ({
    currentUser: state.currentUser.user,
  })
)(CalendlyButton)
